import store from '@/store';
import { normalizeUiLocale } from '@/locales/language'

const KEFU_LOCALES = {
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  en: 'en-US',
  Vietnamese: 'vi-VN'
}

export function getKefuLanguage(locale = localStorage.getItem('language')) {
  const normalizedLocale = normalizeUiLocale(locale)
  return KEFU_LOCALES[normalizedLocale] || KEFU_LOCALES['zh-CN']
}

const KEFU_GROUPS = { 'zh-CN': 1, 'zh-TW': 2, en: 0 }
let loadedKefuGroup = null
let requestedKefuGroup = null
let requestedKefuLocale = null

export function getKefuGroup(locale = localStorage.getItem('language')) {
  const group = KEFU_GROUPS[normalizeUiLocale(locale)]
  return group == null ? 0 : group
}

function syncKefuCustomer (widget, selectedLocale) {
  const userInfo = store.state.token ? (store.state.userInfo || {}) : {}
  widget.call('set_customer_name', userInfo.username || '')
  // Replace business metadata so logout does not leave the previous account displayed.
  // These variables provide context, not authenticated LiveChat customer identity.
  widget.call('set_session_variables', {
    Login: userInfo.username || '',
    'User ID': userInfo.id == null ? '' : String(userInfo.id),
    language: getKefuLanguage(selectedLocale), // 客服可见的页面语言；窗口语言由 LiveChat 后台配置
  })
}

function isKefuReady (widget) {
  return widget && widget._h !== null
}

function createKefuWidget () {
  const widget = window.createLiveChatWidget && window.createLiveChatWidget()
  if (!widget || typeof widget.call !== 'function') return null

  window.__lc.group = requestedKefuGroup
  loadedKefuGroup = requestedKefuGroup
  syncKefuCustomer(widget, requestedKefuLocale)
  widget.once('ready', function () {
    if (window.LiveChatWidget !== widget || requestedKefuGroup === loadedKefuGroup) return
    replaceKefuWidget(widget)
  })
  widget.init()
  return widget
}

function replaceKefuWidget (widget) {
  if (widget && typeof widget.call === 'function' && isKefuReady(widget)) {
    // The LiveChat SDK synchronously removes its globals when destroyed.
    widget.call('destroy')
  }
  loadedKefuGroup = null
  createKefuWidget()
}

export function initKefu (locale) {
  const selectedLocale = locale || localStorage.getItem('language')
  let widget = window.LiveChatWidget
  if (!widget || typeof widget.call !== 'function') return

  syncKefuCustomer(widget, selectedLocale)
  if (!selectedLocale) return

  requestedKefuLocale = selectedLocale
  requestedKefuGroup = getKefuGroup(selectedLocale)
  if (loadedKefuGroup === null) {
    window.__lc.group = requestedKefuGroup
    loadedKefuGroup = requestedKefuGroup
    widget.once('ready', function () {
      if (window.LiveChatWidget !== widget || requestedKefuGroup === loadedKefuGroup) return
      replaceKefuWidget(widget)
    })
    widget.init()
  } else if (loadedKefuGroup !== requestedKefuGroup && isKefuReady(widget)) {
    replaceKefuWidget(widget)
  }
}

export function openKefu () {
  const group = getKefuGroup()
  if (!window.LiveChatWidget || typeof window.LiveChatWidget.call !== 'function') {
    window.location.assign(`https://direct.lc.chat/19934543/${group || ''}`)
    return
  }
  initKefu(localStorage.getItem('language') || 'zh-CN')
  const widget = window.LiveChatWidget
  if (widget && typeof widget.call === 'function') widget.call('maximize')
}
export function getCurrentDay() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;  // 返回格式如 2025-06-07
}

export function formatDate(timestamp, type = 'day') {
  if (!timestamp) return '';

  // 如果是秒级时间戳（10 位），乘 1000 转成毫秒
  if (timestamp.toString().length === 10) {
    timestamp = timestamp * 1000;
  }

  const date = new Date(timestamp);
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const vietnam = new Date(utc + 7 * 60 * 60000);

  const y = vietnam.getFullYear();
  const m = ('0' + (vietnam.getMonth() + 1)).slice(-2);
  const d = ('0' + vietnam.getDate()).slice(-2);
  const h = ('0' + vietnam.getHours()).slice(-2);
  const min = ('0' + vietnam.getMinutes()).slice(-2);
  const s = ('0' + vietnam.getSeconds()).slice(-2);

  if(type === 'day') {
    return `${y}-${m}-${d}`;
  }else {
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }
}
export function translateText(arr) {

  return new Promise((resolve, reject) => {
    // console.log(localStorage.getItem("language") === 'zh-CN')
    // if(localStorage.getItem("language") === 'zh-CN') {
      resolve(arr);
    // }else {
    //   translate.request.translateText({
    //     from: 'chinese_simplified',  // 中文
    //     to: 'vietnamese',            // 越南
    //     texts: arr
    //   }, function(data){
    //     resolve(data.text)
    //   }, function(err){
    //     resolve(arr)
    //   });
    // }

  })
}

//  兼容pc端rem
export function setRem() {
  const DESIGN_WIDTH = 1920; // 设计稿宽度
  const MAX_WIDTH = 512;     // PC 最大宽度

  let screenWidth = document.documentElement.clientWidth;

  // 如果屏幕大于 512px，则按照最大宽度计算
  if (screenWidth > MAX_WIDTH) screenWidth = MAX_WIDTH;

  // 设置 html 的 font-size
  document.documentElement.style.fontSize = screenWidth / 10 + 'px';
}
// 判断是否为移动端
export function isMobile() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // 移动端常见关键字
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}



// WEBPACK FOOTER //
// ./src/common/utils.js